import React from "react";
import GoogleMapReact from "google-map-react";

import { useGql } from "../Core/gqlHooks";
import { queryPageContact } from "../Core/services";
import PageLayout from "../Components/pageLayout/PageLayout";

import "./Contact.scss";
import { ReactComponent as IconFacebook } from "../Assets/images/icn-facebook.svg";
import { ReactComponent as IconInstagram } from "../Assets/images/icn-instagram.svg";
import { GOOGLE_MAP_API_KEY } from "../Core/Constant";
import MarkerLogo from "../Components/map/MarkerLogo";
import { GOOGLE_MAPS_DIRECTIONS_URL, usePageSeo } from "../Core/utils";

const center = {
  lat: 45.527999065894576,
  lng: -73.59141853387052,
};

const Contact: React.FC = () => {
  const { data, loading } = useGql({
    query: queryPageContact,
  });

  const page = data?.pageContact?.data?.attributes;

  usePageSeo({
    title: page?.pageTitle,
    keywords: page?.keywords,
  });

  const addressLines = page?.address?.split("\n") ?? [];

  return (
    <PageLayout
      className="contact-container"
      contentClassName="contact"
      title="Nous Contacter"
      after={
        !loading && (
          <div className="map-container">
            <a
              className="btn -green btn-itineraire"
              href={GOOGLE_MAPS_DIRECTIONS_URL}
              target="_blank"
              rel="noreferrer"
            >
              Itinéraire
            </a>
            <GoogleMapReact
              bootstrapURLKeys={{ key: GOOGLE_MAP_API_KEY }}
              defaultCenter={center}
              defaultZoom={17}
            >
              <MarkerLogo lat={center.lat} lng={center.lng} />
            </GoogleMapReact>
          </div>
        )
      }
    >
      {!loading && page && (
        <div className="contact-info-container">
          <div className="contact-info">
            <h3>Communication</h3>
            <div className="contact-section">
              <p className="contact-row">
                <span className="contact-label">Tel:</span>{" "}
                <span className="contact-value">{page.tel}</span>
              </p>
              <p className="contact-row">
                <span className="contact-label">Courriel:</span>{" "}
                <span className="contact-value">{page.email}</span>
              </p>
              <p className="contact-row">
                <a
                  href={page.socialMedia.facebook}
                  target="_blank"
                  rel="noreferrer"
                  className="contact-value"
                >
                  <IconFacebook className="icon-social" />
                  Facebook
                </a>
              </p>
              <p className="contact-row">
                <a
                  href={page.socialMedia.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="contact-value"
                >
                  <IconInstagram className="icon-social" />
                  Instagram
                </a>
              </p>
            </div>
          </div>
          <div className="contact-info">
            <h3>En personne</h3>
            <div className="contact-section">
              <p>
                {addressLines.map((line: string, idx: number) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <React.Fragment key={idx}>
                    <span>{line}</span>
                    <br />
                  </React.Fragment>
                ))}
              </p>
              <a
                className="link"
                href={GOOGLE_MAPS_DIRECTIONS_URL}
                target="_blank"
                rel="noreferrer"
              >
                Itinéraire
              </a>
            </div>
          </div>
          <div className="contact-info">
            <h3>Les heures d&apos;ouvertures</h3>
            <div className="contact-section">
              <ul className="heures-ouverture">
                {page.openingHours.map((day: { day: string; hour: string }) => (
                  <li key={day.day}>
                    <span>{day.day}</span>{" "}
                    <span className="heure">{day.hour}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
};

export default Contact;
